"use strict";
(function(global) {
    class InputElement extends HTMLDivElement {
        static lastId = 1;

        constructor(label: string, value: string, ...args) {
            super(...args);

            this._label = label;
            this.input = document.createElement('input');
            this.input.value = value;
            this.input.setAttribute('id', `some_funny_input_id_${InputElement.lastId++}`);
            this.input.classList.add('input-sm', 'form-control', 'fg-input');
            this.input.style.minWidth = '350px';

            // noinspection JSUnusedLocalSymbols
            this.input.addEventListener('focus', e => {
                this.input.parentElement.classList.add('fg-toggled');
            });

            // noinspection JSUnusedLocalSymbols
            this.input.addEventListener('blur', e => {
                if (!this.input.value || !this.input.value.length) {
                    this.input.parentElement.classList.remove('fg-toggled');
                }
            });
        }

        get value(): string {
            return this.input.value;
        }

        set disabled(val: boolean): void {
            if (val) this.input.setAttribute('disabled', 'disabled');
            else this.input.removeAttribute('disabled');
        }

        connectedCallback(): void {
            this.classList.add('form-group', 'fg-float', 'm-b-5');
            this.style.setProperty('margin-bottom', '30px', 'important');

            const div = document.createElement('div');
            div.classList.add('fg-line');

            if (this.input.value && this.input.value.length) {
                div.classList.add('fg-toggled');
            }

            div.appendChild(this.input);
            this.appendChild(div);

            const label = document.createElement('label');
            label.classList.add('fg-label');
            label.setAttribute('for', this.input.getAttribute('id'));
            label.innerText = this._label;

            this.appendChild(label);

            delete this._label;
        }
    }

    class EditFormElement extends HTMLDivElement {
        constructor(mo: ManagedObject, ...args) {
            super(...args);

            this.mo = mo;
        }

        connectedCallback(): void {
            this.appendChild(new InputElement('Firma', this.mo.companyName || '-')).disabled = true;
            this.appendChild(new InputElement('Obiekt nadrzędny', (this.mo.parent || {}).name || '-')).disabled = true;
            this.appendChild(new InputElement('Nazwa', this.mo.name || '-')).disabled = true;
            this.appendChild(this.input = new InputElement('Nazwa wyświetlana', this.mo.displayName || ''));
        }

        get value(): Object {
            return {
                label: this.input.value
            };
        }
    }

    class ManagedObject {
        constructor(id: number, name: string, displayName: string | null, companyName: string | null, children: ManagedObject[], parent: ManagedObject | null) {
            this._id = id;
            this._name = name;
            this._displayName = displayName;
            this._companyName = companyName;
            this._children = children;
            this._parent = parent;
        }

        get id(): number {
            return this._id;
        }

        get name(): string {
            return this._name;
        }

        get displayName(): string | null {
            return this._displayName;
        }

        get companyName(): string | null {
            return this._companyName;
        }

        get children(): ManagedObject[] {
            return this._children;
        }

        get parent(): ManagedObject | null {
            return this._parent;
        }

        set displayName(name: string) {
            this._displayName = name;
        }
    }


    class RowElement extends HTMLLIElement {
        mo: ManagedObject;

        constructor(mo: ManagedObject, ...args) {
            super(...args);

            this.mo = mo || {};
        }

        connectedCallback(): void {
            const div = document.createElement('div');
            div.classList.add('checkbox');

            const label = document.createElement('label');

            const input = this.input = document.createElement('input');
            input.setAttribute('type', 'checkbox');
            input.setAttribute('name', `managed_object_${this.mo.id}`);
            input.setAttribute('data-mo', this.mo.id);
            input.addEventListener('change', e => {
                e.preventDefault();
                e.stopPropagation();

                if (this.checkable) {
                    for (const input of this.inputs) {
                        // noinspection JSUnresolvedVariable
                        input.checked = e.target.checked;
                    }
                } else {
                    let checked = false;

                    for (const input of this.inputs) {
                        if (!input.checked) {
                            checked = true;
                            break;
                        }
                    }

                    for (const input of this.inputs) {
                        input.checked = checked;
                    }

                    e.target.checked = false;
                }

                this.dispatchEvent(createEvent('change', input.checked));
            });

            if (this.mo.companyName && this.mo.children && this.mo.children.length && !this.mo.children.filter(child => !child.companyName).length) {
                input.setAttribute('disabled', 'disabled');
            }

            if (this.mo.companyName && (!this.mo.children || !this.mo.children.length)) {
                input.setAttribute('disabled', 'disabled');
            }

            const i = document.createElement('i');
            i.classList.add('input-helper');

            const txt = this.textNode = document.createTextNode(this.label);

            const button = document.createElement('a');
            button.innerText = 'Edytuj';
            button.style.marginLeft = '10px';
            button.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();

                this.onEdit();
            });

            label.appendChild(input);
            label.appendChild(i);
            label.appendChild(txt);
            label.appendChild(button);
            div.appendChild(label);
            this.appendChild(div);

            if (this.mo.children && this.mo.children.length) {
                const ul = document.createElement('ul');

                for (const child of this.mo.children) {
                    ul.appendChild(new RowElement(child)).addEventListener('change', (e: CustomEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        // noinspection JSUnresolvedVariable
                        this.onChildChange(e.target.input);
                    });
                }

                this.appendChild(ul);
            }
        }

        remove(): void {
            if (!this.parentElement) {
                return;
            }

            this.style.transition = 'none';
            this.style.height = `${this.scrollHeight}px`;
            this.style.overflow = 'hidden';
            this.style.transition = '300ms';

            setTimeout(() => {
                this.style.height = '0';

                setTimeout(() => {
                    super.remove();
                }, 300);
            });
        }

        onChildChange(target: HTMLInputElement): void {
            if (this.checkable) {
                let checked = true;

                if (!target.checked) {
                    checked = false;
                } else {
                    for (const input of this.inputs) {
                        if (!input.checked) {
                            checked = false;
                            break;
                        }
                    }
                }

                if (!checked) {
                    this.input.checked = checked;
                }
            }

            this.dispatchEvent(createEvent('change'));
        }

        onEdit(): void {
            const form = new EditFormElement(this.mo);
            const popup = new HTMLElements.PopupElement();
            popup.header = 'Edycja';
            popup.content = form;
            const closeBtn = popup.addButton('Zamknij', () => popup.hide());
            const saveBtn = popup.addButton('Zapisz', () => {
                saveBtn.setAttribute('disabled', 'disabled');
                closeBtn.setAttribute('disabled', 'disabled');
                popup.closeable = false;

                ApiConnect.put(`/operator/managed-object/${this.mo.id}`, form.value)
                    .then(response => { if (!response.status || response.status !== 'success') throw new Error(response.message || 'Wystąpił błąd podczas zapisu.'); })
                    .then(() => {
                        console.log('ok');
                        this.mo.displayName = form.value.label;
                        this.relabel();
                        popup.hide();
                    }).catch((err: Error) => {
                        console.log('error', err);
                        popup.content = err.message;
                        popup.closeable = true;
                        saveBtn.remove();
                        closeBtn.removeAttribute('disabled');
                    });
            });
            popup.show();
        }

        relabel(): void {
            this.textNode.textContent = this.label;
        }

        get label(): string {
            let label = this.mo.name;

            if (this.mo.displayName || this.mo.companyName) {
                const parts = [];

                if (this.mo.companyName) {
                    parts.push(`firma: ${this.mo.companyName}`);
                }

                if (this.mo.displayName) {
                    parts.push(`nazwa wyświetlana: ${this.mo.displayName}`);
                }

                label += ` (${parts.join(', ')})`;
            }

            return label;
        }

        get checkable(): boolean {
            if (typeof this._checkable === 'boolean') {
                return this._checkable;
            }

            for (const child of this.mo.children || []) {
                if (child.companyName) {
                    return this._checkable = false;
                }
            }

            return this._checkable = true;
        }

        get inputs(): HTMLInputElement[] {
            if (!this._inputs) {
                this._inputs = [];

                for (const child of this.mo.children || []) {
                    if (!child.companyName) {
                        this._inputs.push(this.querySelector(`input[name="managed_object_${child.id}"]`));
                    }
                }
            }

            return this._inputs;
        }
    }

    class ManagedObjectsController {
        constructor(options: Object) {
            this.container = document.getElementById('list-container');
            this.container.appendChild(this.loadingBox = document.createElement('li'));

            this.deleteButton = document.getElementById('delete-button');
            this.deleteButton.setAttribute('disabled', 'disabled');
            this.deleteButton.addEventListener('click', e => {
                e.preventDefault();

                this.onDeleteRequest(this.selected.map((row: RowElement) => row.mo.id));
            });

            this.loadingBox.innerText = 'Trwa wczytywanie danych...';
            this.loadingBox.style.textAlign = 'center';
            this.loadingBox.style.paddingBottom = this.loadingBox.style.paddingTop = '15px';
            this.loadingBox.style.height = `${this.loadingBox.scrollHeight}px`;
            this.loadingBox.style.transition = '300ms';

            this.load(options.loadUrl);
        }

        load(url: string): void {
            ApiConnect.get(url).then(data => data.map(obj => this.toManagedObject(obj))).then((mos: ManagedObject[]) => {
                this.loadingBox.style.height = '0';

                setTimeout(() => {
                    this.loadingBox.remove();

                    for (const mo of mos) {
                        const row = this.container.appendChild(new RowElement(mo));
                        row.addEventListener('change', e => this.onChange(e));
                        row.style.height = '0';
                        row.style.overflow = 'hidden';
                        row.style.transition = '600ms';
                        row.style.height = `${row.scrollHeight}px`;
                    }
                }, 350);
            }).catch(err => {
                console.error(err);
                this.loadingBox.innerText = 'Wystąpił błąd podczas wczytywania danych.';
            });
        }

        onChange(e: CustomEvent): void {
            e.preventDefault();
            e.stopPropagation();

            if (this.selected.length) {
                this.deleteButton.removeAttribute('disabled');
            } else {
                this.deleteButton.setAttribute('disabled', 'disabled');
            }
        }

        onDeleteRequest(ids: number[]): void {
            const popup = new HTMLElements.PopupElement();
            popup.header = 'To dzieje się naprawdę!';
            popup.content = `W kolejnym kroku usuniemy${ids.length > 2 ? ' aż' : ''} ${ids.length} ${ids.length === 1 ? 'obiekt ' +
                'chroniony' : (ids.length % 10 > 1 && ids.length % 10 < 5 && ids.length % 100 / 10 !== 1 ? 'obiekty chronione' : 'obiektów chronionych')}.\n\nCzy jest to Twoja ostateczna decyzja?`;
            const no = popup.addButton('Nie', () => popup.hide());
            const btn = popup.addButton('Tak', () => {
                btn.disabled = true;
                ApiConnect.delete('/operator/managed-object', {ids})
                    .then(response => { if (!response.status || response.status !== 'success') throw new Error(response.message || 'Wystąpił błąd podczas usuwania rekordów.'); })
                    .then(() => {
                        for (const id of ids) {
                            const input = document.querySelector(`input[name="managed_object_${id}"]`);

                            if (input) {
                                input.closest('li, mo-row').remove();
                            }
                        }

                        popup.hide();
                    }).catch((err: Error) => {
                        popup.header = '';
                        popup.content = err.message;
                        btn.remove();
                        no.innerText = 'Zamknij';
                    });
            });
            popup.show();
        }

        toManagedObject(data: Object, parent: ManagedObject): ManagedObject {
            const children = [];
            const result = new ManagedObject(data.id, data.name, data.label, data.companyName, children, parent);

            if  (data.children && data.children.length) {
                for (const child of data.children) {
                    children.push(this.toManagedObject(child, result));
                }
            }

            return result;
        }

        get selected(): RowElement[] {
            const inputs: HTMLInputElement[] = Array.from(document.querySelectorAll('input[name^="managed_object_"]')).filter(input => input.checked);
            const results: RowElement[] = [];

            for (const input of inputs) {
                results.push(input.closest('li, mo-row'));
            }

            return results;
        }
    }

    customElements.define('mo-row', RowElement, {extends: 'li'});
    customElements.define('mo-edit-form', EditFormElement, {extends: 'div'});
    customElements.define('mo-input', InputElement, {extends: 'div'});

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.ManagedObjectsController = ManagedObjectsController || {};

})(window);
